
export class DataCommitPendingCollections {}

